import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import saveAs from 'file-saver';
import { AssetmanagementService, AttachmentDialogService } from 'guideline/feature-attachment';
import { mapMimeTypeToAttachmentType } from 'shared/domain';
import {
  AttachmentCardComponent,
  ConfirmationDialogItem,
  ConfirmationDialogNewComponent,
  DialogService,
  IconDirective,
  ButtonDirective,
} from 'shared/ui-common';

import { Attachment } from '@treetop/shared/model';

@Component({
  standalone: true,
  imports: [TranslocoModule, MatButtonModule, MatIconModule, IconDirective, AttachmentCardComponent, ButtonDirective],
  selector: 'tt-sidebar-attachments',
  templateUrl: './attachments.component.html',
  styleUrls: ['./attachments.component.scss'],
})
export class AttachmentsComponent {
  @Input() public attachments: Attachment[];
  @Output() public attachmentsChange = new EventEmitter<Attachment[]>();
  @Input() public storeConnected: boolean;

  private attachmentDialogService = inject(AttachmentDialogService);
  private assetServer = inject(AssetmanagementService);
  private dialogService = inject(DialogService);
  private translocoService = inject(TranslocoService);

  protected openAttachmentDialog(): void {
    this.attachmentDialogService.openFlowchartAttachmentDialog(this.attachments ? this.attachments : [], this.assignAttachments.bind(this));
  }

  protected assignAttachments(attachments: Attachment[]): void {
    if (this.storeConnected) {
      this.attachments = attachments;
      this.attachmentsChange.emit(this.attachments);
    } else {
      this.attachments = attachments;
      this.attachmentsChange.emit(this.attachments);
    }
  }

  protected downloadAttachment(attachment: Attachment) {
    this.assetServer.downloadAttachment(attachment.id).subscribe((response) => {
      saveAs(response.body, attachment.originalName, { autoBom: false });
    });
  }

  protected deleteAttachment(id: string, displayName: string) {
    const dialog = this.dialogService.open<ConfirmationDialogItem>(ConfirmationDialogNewComponent, {
      width: 400,
      title: this.translocoService.translate('DeleteAttachment'),
      data: {
        text: this.translocoService.translate('DeleteAttachmentConfirmation', { title: displayName }),
        confirmButton: this.translocoService.translate('Delete'),
      },
    });

    dialog.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.attachments = this.attachments.filter((attachment) => attachment.id !== id);
        this.attachmentsChange.emit(this.attachments);
      }
    });
  }

  protected iconKey(attachment: Attachment) {
    return mapMimeTypeToAttachmentType(attachment.contentType);
  }
}
